import React, { ReactNode } from 'react';
import { Avatar } from 'antd';
import styles from './COAvatar.module.scss';
import { AvatarEnums } from 'enums/COAvatarEnums';

export interface COAvatarProps {
  children?: ReactNode;
  icon?: ReactNode;
  size?: number;
}
const COAvatar: React.FC<COAvatarProps> = ({ children, icon, size }: COAvatarProps) => {
  return (
    <div>
      {icon ? (
        <Avatar size={size ? size : 40} src={icon} alt={AvatarEnums.imageAlt} />
      ) : (
        <Avatar className={styles.avatarContainer} size={size ? size : 40}>
          {children}
        </Avatar>
      )}
    </div>
  );
};

export default COAvatar;
